import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * FoldableSection — V14.78 : section latérale repliable (petite flèche).
 * Utilisée par les panneaux de l'Éditeur Plan (Murs détectés, Superposition
 * étages, Escaliers, Duplication…).
 */
export const FoldableSection = ({
  title, icon: Icon, iconClass = 'text-gray-300', badge = null,
  defaultOpen = true, children, testid, extraHeader = null,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="px-2.5 py-2 border-b" style={{ borderColor: 'var(--c-border)' }} data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-1.5 text-left"
        data-testid={testid ? `${testid}-toggle` : undefined}
      >
        {Icon && <Icon className={`w-3 h-3 ${iconClass}`} />}
        <h4 className={`text-[11px] font-semibold ${iconClass}`}>{title}</h4>
        {badge}
        <ChevronDown
          className={`w-3 h-3 ml-auto text-gray-500 transition-transform ${open ? '' : '-rotate-90'}`}
        />
      </button>
      {extraHeader}
      {open && children}
    </div>
  );
};
